import * as React from "react";

const SvgSupport = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={color} fillRule="nonzero">
      <path d="M20 12a8 8 0 0 1-8 8v2c5.523 0 10-4.477 10-10h-2ZM12 20a8 8 0 0 1-8-8H2c0 5.523 4.477 10 10 10v-2ZM4 12a8 8 0 0 1 8-8V2C6.477 2 2 6.477 2 12h2ZM12 4a8 8 0 0 1 8 8h2c0-5.523-4.477-10-10-10v2ZM15 12a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5h-2ZM12 15a3 3 0 0 1-3-3H7a5 5 0 0 0 5 5v-2Z" />
      <path d="M9 12a3 3 0 0 1 3-3V7a5 5 0 0 0-5 5h2ZM12 9a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5v2Z" />
      <path d="M17.657 4.929 14.12 8.464l1.415 1.415 3.535-3.536zM14.121 15.536l3.536 3.535 1.414-1.414-3.536-3.536zM9.879 8.464 6.343 4.93 4.93 6.343 8.464 9.88zM8.464 14.121 4.93 17.657l1.414 1.414 3.536-3.536z" />
    </g>
  </svg>
);

export default SvgSupport;
